import { pontoTipo } from '../types/Ponto.ts';
import { Controller } from '../Controller.ts';

export class Buttons {
    private controller: Controller;
    
    constructor(controller: Controller) {
        this.controller = controller;
    }

    public Entrada = () => {
        this.controller.pushEvent(new Date(), pontoTipo.INICIO);
    }

    public Pausa = () => {
        this.controller.pushEvent(new Date(), pontoTipo.PAUSA);
    }

    public Saida = () => {
        this.controller.pushEvent(new Date(), pontoTipo.FIM);
    }
}